<template>
  <SAutocomplete
    v-model="model"
    v-model:filter="filter"
    clear-filter-on-close
    disable-filter
    :error-label="tr('company_registration_form.fields.product.errorLabel')"
    :items="items"
    :label="tr('company_registration_form.fields.product.label')"
    multiple
    name="product"
    open-on-focus
    :placeholder="placeholderText"
    required
    :tooltip="tr('company_registration_form.fields.product.tooltip')"
    v-on="gtmListeners"
  />
</template>

<script setup lang="ts">
import type { PropType } from "vue";

import { computed, ref } from "vue";

import type { LocaleMorpheus } from "@solvari/translations";

import { SAutocomplete } from "@solvari/common-fe";
import { useModel } from "@solvari/common-fe/composables";
import { useI18nCompanyRegistrationForm } from "@solvari/translations";

import { useGtmListeners } from "@/composables/useGtmListeners";
import useProductList from "@/composables/useProductList";

const { tr } = useI18nCompanyRegistrationForm();

const props = defineProps({
  modelValue: {
    type: Array as PropType<number[] | null>,
    default: null,
  },
  locale: {
    type: String as PropType<LocaleMorpheus>,
    required: true,
  },
});

const emit =
  defineEmits<(event: "update:modelValue", value: number[] | null) => void>();

const model = useModel("modelValue", props, emit);

const filter = ref("");

const { results: productList } = useProductList(filter, () => props.locale);
const items = computed(() => {
  return productList.value.map((item) => ({
    label: item.name,
    value: Number(item.objectID),
  }));
});

const placeholderText = computed(() => {
  return model.value && model.value.length > 0 ? "" : undefined;
});

const gtmListeners = useGtmListeners(
  "product",
  tr("company_registration_form.fields.product.label"),
);
</script>
